import { connect, ConnectedProps } from 'react-redux';
import { StateType } from '../../../state/state.types';

const mapState = (
  { queryParams, results }: StateType,
  { type }: { type: keyof StateType['results']['counts'] },
) => ({
  url: `/search?q=${results.query}&type=${type}`,
  selected: queryParams.type === type,
});

export const Connect = connect(mapState);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
